import styles from './InputField.styles.scss';
export const inputFieldDefinition = (baseName, template) => ({
    baseName,
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true,
    },
});
